import saveAs from 'file-saver';

export const getCallsMetrics = (params, successCallback = () => {}) => {
  fetch(`/api/v1/calls_metrics?${objToQueryString(params)}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then((response) => response.json())
    .then((data) => {
      successCallback(data);
    });
};

export const getCallsMetricsExport = (params) => {
  return fetch(`/api/v1/calls_metrics/export?${objToQueryString(params)}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/csv',
    },
  })
    .then((response) => {
      const filename = response.headers.get('X-Filename') || 'calls_metrics.csv';
      return response.blob().then((blob) => ({ blob, filename }));
    })
    .then(({ blob, filename }) => {
      saveAs(blob, filename);
      return new Promise((resolve) => {
        setTimeout(resolve, 100);
      });
    });
};
